import React from 'react'
import {
Box,
Button,
Grid,
Select,
useLocation,
useCallback,
useState,
useEffect,
GetCookie,
toast,
Modal,
Switch,
} from '../../Libraries/Post/GetAllPostRelatedToScreen/AllPosts/index'
import {
  FormControl,
  FormGroup,
  FormControlLabel,
  RadioGroup,
  Radio,
} from "../../Libraries/Post/Customization/index";
import {
  useGetSelectiveNewsMutation,
  useGetRSSNewsMutation,
  useUpdateScreenFooterOptionMutation,
  useUpdateScreenConfigsMutation,
  useGetScreenConfigsMutation,
} from '../../Redux/service/AllEmpData';
import Marquee from "react-fast-marquee";
import {
    TextField,
} from "@mui/material";

export default function FooterContent({ currentScreen }) {
  const [footerRssLink, setFooterRssLink] = useState('');
  const [footerText, setFooterText] = useState('');
  const [showFooterSettings, setShowFooterSettings] = useState(false);
  const [openLiveView, setOpenLiveView] = useState(false);
  const [marqueeText, setMarqueeText] = useState([]);
  const [footerColors, setFooterColors] = useState({ bg_color: '#000000', text_color: '#ffffff' });

  const [getSelectiveNews] = useGetSelectiveNewsMutation();
  const [getRSSNews] = useGetRSSNewsMutation();
  const [updateScreenFooterOption] = useUpdateScreenFooterOptionMutation();
  const [updateScreenConfigs] = useUpdateScreenConfigsMutation();
  const [getConfigsData] = useGetScreenConfigsMutation();

  const [selectedFooterOption, setSelectedFooterOption] = useState(currentScreen?.footer_option || 'none');

  // Populate initial footer value
  useEffect(() => {
    if (!currentScreen) return;

    setSelectedFooterOption(currentScreen.footer_option || 'none');

    if (currentScreen.footer_option === 'RSS') setFooterRssLink(currentScreen.footer_value);
    else if (currentScreen.footer_option === 'Text') setFooterText(currentScreen.footer_value);

    getScreenConfigsData();
  }, [currentScreen]);

  const getScreenConfigsData = async () => {
    if (!currentScreen) return;
    try {
      const formData = new FormData();
      formData.append('txt_customer_id', localStorage.getItem('txt_customer_id'));
      formData.append('security_token', await GetCookie('es_token'));
      formData.append('ser_screen_id', currentScreen.ser_screen_id);

      const res = await getConfigsData(formData).unwrap();
      if (res.connection === 'true' && res.status === 'true' && res.data?.footer) {
        const config = res.data.footer;
        setFooterColors({
          bg_color: config.bg_color || '#000000',
          text_color: config.text_color || '#ffffff',
        });
      }
    } catch (error) {
            console.error(error);
            toast.error(error.status);
            }
  };

  const handleLiveView = async () => {
    if (!currentScreen) return;

    if (['News', 'Urdu News', 'English News', 'Cricinfo'].includes(selectedFooterOption)) {
      const formData = new FormData();
      formData.append('txt_customer_id', localStorage.getItem('txt_customer_id'));
      formData.append('security_token', await GetCookie('es_token'));
      formData.append('footer_key', selectedFooterOption);

      const res = await getSelectiveNews(formData).unwrap();
      if (res.status === 'true' && res.connection === 'true') {
        setMarqueeText(res.data);
        setOpenLiveView(true);
        toast.success(res.message);
      } else {
        toast.error(res.message);
      }
    } else if (selectedFooterOption === 'RSS') {
      const formData = new FormData();
      formData.append('txt_rss_link', footerRssLink);

      const res = await getRSSNews(formData).unwrap();
      if (res.status === 'true') {
        setMarqueeText(res.data);
        setOpenLiveView(true);
        toast.success(res.message);
      } else {
        toast.error(res.message);
      }
    } else if (selectedFooterOption === 'Text') {
      setMarqueeText([{ txt_news_title: footerText }]);
      setOpenLiveView(true);
    }
  };

  const handleUpdateScreenFooterOption = useCallback(async () => {
    if (!currentScreen) return;
    try {
      const formData = new FormData();
      formData.append('footer_option', selectedFooterOption);
      if (selectedFooterOption === 'RSS') formData.append('footer_value', footerRssLink);
      else if (selectedFooterOption === 'Text') formData.append('footer_value', footerText);
      else formData.append('footer_value', 'N/A');

      formData.append('txt_customer_id', localStorage.getItem('txt_customer_id'));
      formData.append('security_token', await GetCookie('es_token'));
      formData.append('ser_screen_id', currentScreen.ser_screen_id);

      const res = await updateScreenFooterOption(formData).unwrap();
      if (res.status === 'true') toast.success(res.message);
      else toast.info(res.message);
    } catch (error) {
            console.error(error);
            toast.error(error.status);
            }
  }, [currentScreen, selectedFooterOption, footerRssLink, footerText]);

  const handleSaveFooterColors = async () => {
    if (!currentScreen) return;
    try {
      const formData = new FormData();
      formData.append('txt_customer_id', localStorage.getItem('txt_customer_id'));
      formData.append('security_token', await GetCookie('es_token'));
      formData.append('ser_screen_id', currentScreen.ser_screen_id);

      formData.append('configuration', JSON.stringify({ footer: footerColors }));

      const res = await updateScreenConfigs(formData).unwrap();
      if (res.connection === 'true' && res.status === 'true') toast.success('Footer colors updated!');
      else toast.error(res.message || 'Failed to update colors');
    } catch (error) {
            console.error(error);
            toast.error(error.status);
            }
  };

  // === RENDER START ===
  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={0} className="flex flex-column  bg bg-white py-3 px-4" sx={{ borderRadius: '16px'}}>
          <Box sx={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", mb:2 }}>
            <h5 style={{ color: "grey" }}><b>Add Footer</b></h5>
            <div className="flex items-center gap-1">
              <span style={{ fontSize:"13px", color:"#666"}}>Settings</span>
              <Switch
                size="small"
                checked={showFooterSettings}
                onChange={(e) => setShowFooterSettings(e.target.checked)}
              />
            </div>
          </Box>

          <div className="row justify-content-between no-gutters ml-1 mr-1">
            <div className="col col-sm-6 col-md-6 col-lg-6 ">
              <FormControl component="fieldset">
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={selectedFooterOption}
                  onChange={(e) => setSelectedFooterOption(e.target.value)}
                >
                  <FormControlLabel value="Urdu News" control={<Radio />} label="Urdu News" />
                  <FormControlLabel value="English News" control={<Radio />} label="English News" />
                  <FormControlLabel hidden value="Cricinfo" control={<Radio />} label="Cricinfo" />
                  <FormControlLabel value="Text" control={<Radio />} label="Text" />
                  {selectedFooterOption === "none" ? null : (
                    <Button 
                        onClick={handleLiveView} 
                        className="capitalized fs-14 fw-bold mt-2 underlined"
                      >
                        Live View
                      </Button>
                  )}
                </RadioGroup>
              </FormControl>
            </div>

            <div className="col col-sm-6 col-md-6 col-lg-6 align-items-right w-100">
              {selectedFooterOption === "RSS" && (
                <div className="form-group col-md-6 mt-3">
                  <label>Footer RSS Link</label>
                  <textarea
                    value={footerRssLink}
                    onChange={(e) => setFooterRssLink(e.target.value)}
                    style={{ overflow:"hidden" }}
                  />
                </div>
              )}

              {selectedFooterOption === "Text" && (
                <div className="form-group col-md-6 mt-3">
                  <label>Footer Text</label>
                  <textarea
                    value={footerText}
                    onChange={(e) => setFooterText(e.target.value)}
                    style={{ overflow:"hidden" }}
                  />
                </div>
              )}

              <Button
                className="capitalized fs-14 fw-bold"
                style={{ float:"right", maxHeight:"40px", fontWeight:"bold", textTransform:"none" }}
                color="primary"
                variant="contained"
                onClick={handleUpdateScreenFooterOption}
              >
                Update Footer
              </Button>
            </div>
          </div>
        </Grid>
      </Box>

       {showFooterSettings && (
          <Box sx={{ mt: 2 }}>
            <Grid
              container
              className="bg bg-white py-4 px-4"
              sx={{ borderRadius: "16px" }}
            >
              <Grid item xs={12}>
                <h6 style={{ fontWeight: 600, color: "#7e7e7e" }}>
                  Footer Configuration
                </h6>
              </Grid>

              {/* Background Color */}
              <Grid item xs={12} sm={6} sx={{ mt: 2 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <input
                    type="color"
                    value={footerColors.bg_color}
                    onChange={(e) =>
                      setFooterColors({
                        ...footerColors,
                        bg_color: e.target.value,
                      })
                    }
                    style={{
                        width: "25px",
                        height: "25px", 
                        border: 'none',
                        cursor: "pointer", 
                        padding: "0px", 
                        marginLeft: "2%",
                        background: "#ffffff",
                        boxShadow: "0 0 8px rgb(193 195 198 / 70%) "
                      }}
                  />
                  <TextField
                    label="Background Color"
                    size="small"
                    value={footerColors.bg_color}
                    onChange={(e) =>
                      setFooterColors({
                        ...footerColors,
                        bg_color: e.target.value,
                      })
                    }
                    fullWidth
                    sx={{
                        fontSize: "14px",
                        // width: "100px",   
                        "& .MuiInputBase-root": {
                        height: "35px", 
                        fontSize: "14px",
                        },
                        "& .MuiInputLabel-root": {
                        fontSize: "12px",  
                        },
                    }}
                  />
                </Box>
              </Grid>

              {/* Text Color */}
              <Grid item xs={12} sm={6} sx={{ mt: 2 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <input
                    type="color"
                    value={footerColors.text_color}
                    onChange={(e) =>
                      setFooterColors({
                        ...footerColors,
                        text_color: e.target.value,
                      })
                    }
                      style={{
                        width: "25px",
                        height: "25px", 
                        border: 'none',
                        cursor: "pointer", 
                        padding: "0px", 
                        marginLeft: "2%",
                        background: "#ffffff",
                        boxShadow: "0 0 8px rgb(193 195 198 / 70%) "
                      }}
                  />
                  <TextField
                    label="Text Color"
                    size="small"
                    value={footerColors.text_color}
                    onChange={(e) =>
                      setFooterColors({
                        ...footerColors,
                        text_color: e.target.value,
                      })
                    }
                    fullWidth
                    sx={{
                      fontSize: "14px",  
                      "& .MuiInputBase-root": {
                      height: "35px", 
                      fontSize: "14px",
                      },
                      "& .MuiInputLabel-root": {
                      fontSize: "12px",  
                      },
                  }}
                  />
                </Box>
              </Grid>

              {/* Save Button */}
              <Grid item xs={12} sx={{ mt: 3 }}>
                <Button
                  variant="contained"
                  size="small"
                  onClick={handleSaveFooterColors}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </Box>
        )}


      {/* Live Marquee */}
       <Modal
          open={openLiveView}
          onClose={() => {
            setOpenLiveView(false);
          }}
          classNames={{
            overlayAnimationIn: "customEnterOverlayAnimation",
            overlayAnimationOut: "customLeaveOverlayAnimation",
            modalAnimationIn: "customEnterModalAnimation",
            modalAnimationOut: "customLeaveModalAnimation",
          }}
          animationDuration={800}
          styles={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
  
            modal: {
              width: "90%",
              height: "15%",
              padding: "unset",
              overflow: "hidden",
            },
            overlay: {
              background: "rgba(0, 0, 0, 0.5)",
            },
            closeButton: {
              background: "yellow",
            },
          }}
          center
        >
          <Marquee
            className="mt-6"
            speed={20}
            direction={
              currentScreen?.footer_option === "Urdu News" ? "right" : "left"
            }
          >
            {marqueeText.map((data) => {
              return <p>{data?.txt_news_title + "                      ."}</p>;
            })}
          </Marquee>
        </Modal>

    </>
  );
}

